import { Clipboard } from '@capacitor/clipboard';
import { CapacitorHttp } from '@capacitor/core';
import Envir from '../components/Envir';

export const clipBoardFunc = Envir.ANDROID_APP ? Clipboard : 0;
export const httpFunc = Envir.ANDROID_APP ? CapacitorHttp : 0;